import { MenuOutlined } from "@ant-design/icons"
import { Button, Flex, Layout } from "antd"
import React from "react"

import Logo from "../../Images/logos/logo.svg?react"
import DevSettingsController from "../../components/DevSettingsController.tsx"
import { useAppDispatch } from "../../hooks/use-app-dispatch.ts"
import { useAppSelector } from "../../hooks/use-app-selector"
import { toggleMobileMenu } from "../../redux/nav/nav.slice.ts"
import NotificationsController from "../Notifications/components/NotificationsController.tsx"
import { GlobalSearch } from "../GlobalSearch/GlobalSearch.tsx"
import { TimezoneDisplay } from "./TimezoneDisplay.tsx"

const { Header: AntHeader } = Layout

export const Header = () => {
  const dispatch = useAppDispatch()
  const isMobile = useAppSelector((state) => state.nav.isMobile)
  const timezone = useAppSelector((state) => state.auth.userInfo?.timezone)

  return (
    <AntHeader
      className={
        "border-border top-0 z-10 sticky h-[var(--header-height)] border-b p-3"
      }
    >
      <Flex justify={"space-between"} align="center">
        <Logo className="h-[48px] -mt-1  w-[110px]" aria-label="Logo" />

        <Flex gap="middle" align="center">
          {/* Timezone display - hidden on mobile */}
          {!isMobile && <GlobalSearch />}

          {timezone && !isMobile && (
            <TimezoneDisplay timezone={timezone} variant="simple" />
          )}

          <NotificationsController />
          {import.meta.env.VITE_APP_SHOW_DEV_PANEL && <DevSettingsController />}
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={() => dispatch(toggleMobileMenu())}
            className="md:hidden shadow-sm border border-gray-100"
            size="large"
          />
        </Flex>
      </Flex>
    </AntHeader>
  )
}
